// @ts-expect-error untyped module
import ToolAccessGuard from 'ui-tool-access/ToolAccessGuard';
import { trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Header } from 'foundations-components/transitional/components/Header';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const header = /*#__PURE__*/_jsx(Header, {
  title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "email-management.header.title"
  }),
  use: "condensed",
  children: /*#__PURE__*/_jsx(Button, {
    "data-test-id": "email-create-button",
    disabled: true,
    size: "sm",
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "email-management.header.createEmail"
    })
  })
});
export default function ProhibitedDashboard() {
  useEffect(() => {
    trackDashboardInteraction({
      otherActions: 'view-locked-screen',
      lockedScreenType: 'tool'
    });
  }, []);
  return /*#__PURE__*/_jsx(ListingPage, {
    "data-test-id": "prohibited-dashboard",
    headerComponent: header,
    children: /*#__PURE__*/_jsx(NavMarker, {
      name: "PROHIBITED_PAGE_CONTAINER",
      children: /*#__PURE__*/_jsx(ToolAccessGuard, {
        scope: "email-access"
      })
    })
  });
}